/**
 * Current fare of a leg for calculations (variance, points redemption).
 *
 * Uses fareDisplay when fares are shown. On hidden-fare services
 * (fareDisplay 0) the latest repriced total lives in fareComponents —
 * leg.service.fare holds the original quote and is not refreshed by
 * reprice, so it is only a last resort for legs without fareComponents.
 */
export function calculationFare(leg: be.Reservation): number {
  const fareDisplay = leg.service?.fareDisplay || 0;
  if (fareDisplay > 0) return fareDisplay;

  const component = leg.service?.fareComponents?.find((fc) => fc.field === "fare")?.value;
  if (component !== undefined) return Number(component) || 0;

  return leg.service?.fare || 0;
}
